import React from 'react';
import { getColor } from '../../common/constants/_colors';
import { Flex } from '../base/layout-components';
import WizardNumber from './WizardNumber';
import styled from 'styled-components';

const Line = styled.div`
  ${({ color, height, lineStyle = 'solid' }) =>
    `border-left: 1px ${lineStyle} ${getColor(color)};
    height: ${height};`}
`;
const WizardSteps = ({ steps, line: { color, lineStyle, height } }) => (
  <Flex direction='column' items='center'>
    {steps.map((step, index) => (
      <>
        <WizardNumber {...step} key={index + 'wizard-number'} />
        {index !== steps.length - 1 && (
          <Line
            data-testid='wizard-line'
            color={color}
            lineStyle={lineStyle}
            height={height}
            key={index + 'wizard-line'}
          />
        )}
      </>
    ))}
  </Flex>
);

export default WizardSteps;
